import { useRef, useState } from "react";
import { connect } from "react-redux";
import {
  SwipeableList,
  SwipeableListItem,
} from "@sandstreamdev/react-swipeable-list";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { setUser } from "../../../store/action/auth";
import HttpService from "../../../services/http_service/HttpService";
import Http from "../../../services/http/Http";
import AuthService from "../../../services/auth/Auth";
import Sweetalert from "../../../components/sweetalert/Sweetalert";
import Card from "../../../components/card";
import UpdateAddress from "./update";
import { Div, Container, ItemValue, SwipeLeft, SwipeRight } from "./style";

const ItemData = (props) => {
  const { user, data, addresses, setAddresses, theme, setUser } = props;

  const updateAddressRef = useRef();

  const [isLoadingSendData, setIsLoadingSendData] = useState(false);

  const showSweetalert = () => {
    var data = {
      title: "",
      text: "آیا مطمئن هستید که می خواهید حذف کنید؟",
      icon: "warning",
      confirmButtonText: "بله، حذف شود",
      cancelButtonText: "خیر",
      confirmed: false,
      confirmedCallBack: deleteAddress.bind(this),
    };

    Sweetalert.confirm(data);
  };

  const deleteAddress = () => {
    if (isLoadingSendData === false) {
      setIsLoadingSendData(true);

      HttpService(user?.token)
        .delete(`user/addresses/${data.id}`)
        .then((response) => {
          let newAddresses = addresses.filter((address) => {
            return address.id !== data.id;
          });

          setAddresses(newAddresses);

          AuthService.setUser(
            {
              ...user,
              address: newAddresses[0],
            },
            setUser
          );

          Http(response?.status, response?.data?.message, props);
        })
        .catch((error) => {
          Http(error?.response?.status, error?.response?.data?.message, props);
        })
        .finally(() => {
          setIsLoadingSendData(false);
        });
    }
  };

  return (
    <>
      <UpdateAddress
        refrence={updateAddressRef}
        data={data}
        addresses={addresses}
        setAddresses={setAddresses}
      />
      <SwipeableList>
        {({ className, ...rest }) => (
          <Card className={`${className} text-right mb-2`}>
            <SwipeableListItem
              swipeLeft={{
                content: (
                  <SwipeLeft>
                    <EditOutlinedIcon />
                  </SwipeLeft>
                ),
                action: () => updateAddressRef.current.changeStatus(),
              }}
              swipeRight={{
                content: (
                  <SwipeRight>
                    <DeleteOutlineOutlinedIcon />
                  </SwipeRight>
                ),
                action: showSweetalert,
              }}
            >
              <Container className="w-100">
                <Card>
                  <Div className="p-2 py-3">
                    {/* <Item theme={theme}>آدرس:</Item> */}
                    <ItemValue className="mr-2" theme={theme}>
                      {data.address}
                    </ItemValue>
                  </Div>
                </Card>
              </Container>
            </SwipeableListItem>
          </Card>
        )}
      </SwipeableList>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    theme: state.theme,
  };
};

export default connect(mapStateToProps, { setUser })(ItemData);
